export const  galleryConstants = {
    GET_GALLERY_SUCCESS:  'GET_GALLERY_SUCCESS',

    SHOW_GALLERY_SUCCESS: 'SHOW_GALLERY_SUCCESS',

    UPDATE_GALLERY_SUCCESS: 'UPDATE_GALLERY_SUCCESS',
   
    REMOVE_GALLERY_SUCCESS: 'REMOVE_GALLERY_SUCCESS',
};